import styles from "./MMVPriceBreakup.module.scss";
import { SplitLayout } from "@components/molecules/SplitLayout";
import { formatToTitleCase, toKebabCase } from "@utils/stringFormatters";
import ImageResponsive from "@components/atoms/ImageResponsive";
import PriceBreakupV2 from "./PriceBreakupV2";
import { cn } from "@utils/utils";

const DELIVERY_TYPE_LABEL = {
  inventory: "Express Delivery",
  adsp: "Standard Delivery",
};

interface PriceBreakupProps {
  price: any;
  isLoggedIn: boolean;
  selectedDelivery: any;
  brandName: string;
  modelName: string;
  variantName: string;
  setIsModalOpen: (val: boolean) => void;
  setIsIntentModalOpen: (val: boolean) => void;
  isInventoryAvailable: boolean;
  cityName: string;
  isSellable: boolean;
  pageType: string;
  carAvailability?: string;
  selectedColor?: any;
  savingBalance?: any;
  environmentCompensation?: number;
  fuelType?: string;
  selectedYear: string;
  onYearChange: (year: string) => void;
  availableYears?: string[];
  isUpsellFlow?: boolean;
}

export default function MMVPriceBreakupV2({
  price,
  isLoggedIn,
  selectedDelivery,
  setIsModalOpen,
  setIsIntentModalOpen,
  isInventoryAvailable,
  brandName,
  modelName,
  variantName,
  cityName,
  isSellable,
  pageType,
  carAvailability,
  selectedColor,
  savingBalance,
  environmentCompensation,
  fuelType,
  selectedYear,
  onYearChange,
  availableYears,
  isUpsellFlow = false,
}: PriceBreakupProps) {
  const { price_breakup: priceBreakup, savings_breakup: savingsBreakup } = price || {};
  const { ex_showroom: exShowroomPrice } = priceBreakup || {};
  const {
    market_price: marketPrice,
    adsp_price: ackoDrivePrice,
    savings: savings,
    deal_type: deliveryOption,
    waiting_period: deliveryDate,
  } = selectedDelivery || {};

  const deliveryType =
    deliveryOption === "Inventory"
      ? DELIVERY_TYPE_LABEL.inventory
      : DELIVERY_TYPE_LABEL.adsp;

  const { otherChargesTotal, otherCharges } = Object.entries(priceBreakup || {}).reduce(
    (acc, [key, value]) => {
      if (key !== "ex_showroom") {
        const hasRegistrationAmount = Object.keys(priceBreakup || {}).some(
          k => k === "Registration Amount"
        );
        if (hasRegistrationAmount && key === "Registration amount") {
          return acc;
        }
        const numValue = parseFloat(String(value)) || 0;
        acc.otherChargesTotal += numValue;
        acc.otherCharges.push({
          label: key,
          value: String(value),
        });
      }
      return acc;
    },
    { otherChargesTotal: 0, otherCharges: [] as { label: string; value: string }[] }
  );

  otherCharges.sort((a, b) => Number(b.value) - Number(a.value));

  return (
    <SplitLayout>
      <div className={styles.carImageSection}>
        <div className={styles.imageWrapper}>
          <ImageResponsive
            filePath={`${toKebabCase(brandName)}/${toKebabCase(modelName)}`}
            imageTag={`Specs`}
            alt={`${brandName} ${modelName}`}
            fill
            className={styles.carImage}
          />
        </div>
      </div>

      <div
        className={cn(
          styles.priceSection,
          isUpsellFlow && styles.upsellPriceSection
        )}
      >
        <PriceBreakupV2
          exShowroomPrice={exShowroomPrice}
          otherChargesTotal={otherChargesTotal.toString()}
          otherCharges={otherCharges}
          onRoadPrice={marketPrice}
          ackoDiscount={savings}
          ackoDrivePrice={ackoDrivePrice}
          deliveryDate={deliveryDate}
          cityName={cityName}
          isLoggedIn={isLoggedIn}
          setIsModalOpen={setIsModalOpen}
          setIsIntentModalOpen={setIsIntentModalOpen}
          isInventoryAvailable={isInventoryAvailable}
          deliveryType={deliveryType}
          isSellable={isSellable}
          brandName={brandName}
          modelName={modelName}
          variantName={variantName}
          pageType={pageType}
          carAvailability={carAvailability}
          savingsBreakup={savingsBreakup}
          selectedColor={selectedColor}
          savingBalance={savingBalance}
          environmentCompensation={environmentCompensation}
          fuelType={fuelType}
          selectedYear={selectedYear}
          onYearChange={onYearChange}
          availableYears={availableYears}
          isUpsellFlow={isUpsellFlow}
        />
      </div>
    </SplitLayout>
  );
}
